import { cx } from "@jugl-web/utils";
import { forwardRef, ReactNode } from "react";
import { PlainButton } from "../../PlainButton";
import { ReactComponent as ChevronDownIcon } from "./assets/chevron-down.svg";

export interface SelectTriggerProps {
  label: ReactNode;
  isOpen?: boolean;
  hasValue?: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  customIcon?: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const SelectTrigger = forwardRef<HTMLButtonElement, SelectTriggerProps>(
  (
    {
      label,
      className,
      isOpen,
      hasValue,
      isDisabled,
      isInvalid,
      customIcon,
      onClick,
      ...props
    },
    ref
  ) => (
    <PlainButton
      {...props}
      ref={ref}
      disabled={isDisabled}
      className={cx(
        "flex w-full items-center justify-between gap-2 overflow-hidden rounded-[10px] border border-solid border-grey-400 bg-white px-5 py-4 transition-colors focus-within:border-transparent",
        "focus-within:border-[#90C9F9] focus-within:ring-1 focus-within:ring-[#90C9F9] focus-within:outline-none focus:border-[#90C9F9] focus:outline-none",
        isOpen && "border-[#90C9F9]",
        isDisabled
          ? "bg-grey-[#FAFAFA] cursor-not-allowed border-dashed border-grey-400 text-grey hover:border-grey-400"
          : "hover:border-[#90C9F9] hover:ring-1 hover:ring-[#90C9F9]",
        isInvalid &&
          "border-solid border-gradients-danger focus-within:border-gradients-danger focus-within:ring-gradients-danger hover:border-gradients-danger",
        className
      )}
      onClick={onClick}
    >
      <span
        className={cx(
          "truncate font-secondary text-base leading-[24px]",
          !hasValue && "text-dark-600"
        )}
      >
        {label}
      </span>
      {customIcon || (
        <ChevronDownIcon
          className={cx(
            "shrink-0 transition-transform",
            !isOpen && "rotate-180"
          )}
        />
      )}
    </PlainButton>
  )
);
